import { Plugin } from 'ckeditor5';
/**
 * NOTE: Baked in to Pleditor editor instance.
 * Simple placeholder plugin that treats placeholders as regular editable text
 * with a data-placeholder attribute.
 */
export class PleditorPlaceholders extends Plugin {
    static get pluginName() {
        return 'PleditorPlaceholders';
    }
    init() {
        this.defineSchema();
        this.defineConverters();
    }
    defineSchema() {
        const { schema } = this.editor.model;
        // Extend $text to allow placeholder attribute
        schema.extend('$text', {
            allowAttributes: ['placeholder'],
        });
        schema.setAttributeProperties('placeholder', {
            copyOnEnter: false,
        });
    }
    defineConverters() {
        const { conversion } = this.editor;
        /**
         * UPCAST: HTML → Model
         * Converts <span data-placeholder="name">content</span> to text with placeholder attribute
         */
        conversion.for('upcast').elementToAttribute({
            view: {
                name: 'span',
                attributes: {
                    'data-placeholder': true,
                },
            },
            model: {
                key: 'placeholder',
                value: (viewElement) => viewElement.getAttribute('data-placeholder'),
            },
        });
        /**
         * EDITING DOWNCAST: Model → View (Editor)
         * Renders text with placeholder attribute as styled span
         */
        conversion.for('editingDowncast').attributeToElement({
            model: 'placeholder',
            view: (attributeValue, { writer }) => writer.createAttributeElement('span', {
                'data-placeholder': attributeValue,
                class: 'placeholder',
            }),
        });
        /**
         * DATA DOWNCAST: Model → HTML
         * Converts back to <span data-placeholder="name">content</span>
         */
        conversion.for('dataDowncast').attributeToElement({
            model: 'placeholder',
            view: (attributeValue, { writer }) => writer.createAttributeElement('span', {
                'data-placeholder': attributeValue,
            }),
        });
    }
}
